import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

// Define an async thunk to fetch data from the API

export const fetchTotalWebsiteVisitor = createAsyncThunk(
  "community/fetchTotalWebsiteVisitor",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/visitor-count");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);